type OpenContactUsMailtoParams = {
  subject: string;
  body: string;
  to?: string;
};

const DEFAULT_CUSTOMER_SUPPORT_EMAIL = 'kunde@koda.dk';
export const WEB_SUPPORT_EMAIL = 'web@koda.dk';

export const openContactUsMailto = ({
  subject,
  body,
  to = DEFAULT_CUSTOMER_SUPPORT_EMAIL,
}: OpenContactUsMailtoParams) => {
  if (typeof window === 'undefined') return;

  window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
